import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import environment from 'src/environments/environment';

@Injectable()
export class StrapiInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (request.url.includes(environment.strapi.domain)) {
      const newRequest = request.clone({
        setHeaders: {
          Authorization: `Bearer ${environment.strapi.token}`,
          "Strapi-Response-Format": "v4",
        },
      });
      return next.handle(newRequest);
    }

    return next.handle(request);
  }
}
